<dashboardnav>
    <cradua-requesttype
    [requestTypes]="requestTypes$ | async"
    (requestType)="onSubmitRequestType($event)"
    (deleteRequestTypeEvent)="onDeleteRequestType($event)"
    *ngIf="(isLoadingRequestType$ | async ) === false"
    >
  </cradua-requesttype>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingRequestType$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
